import React from 'react';
import PropTypes from 'prop-types';

import { AlertWrap } from '../../container/styled';

function Alert(props) {
  const { type, icon, message, description, showIcon, outlined, closable, closeText, action, className, banner } =
    props;

  return (
    <AlertWrap
      message={message}
      type={type}
      className={className}
      action={action}
      description={description}
      closable={closable}
      showIcon={showIcon && showIcon}
      outlined={outlined}
      closeText={closeText && closeText}
      icon={icon && icon}
      banner={banner}
    />
  );
}

Alert.defaultProps = {
  type: 'success',
  message: 'Hello there! A simple success alert—check it out!',
};

Alert.propTypes = {
  type: PropTypes.oneOf(['success', 'info', 'warning', 'error']),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  showIcon: PropTypes.bool,
  outlined: PropTypes.bool,
  action: PropTypes.node,
  closable: PropTypes.bool,
  closeText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.node,
  className: PropTypes.string,
  banner: PropTypes.bool,
};

export default Alert;
